import { z } from "zod";

export const depositFormSchema = z.object({
  amount: z.coerce
    .number()
    .min(0.01, "Amount must be at least 0.01")
    .max(999_999_999.99, "Amount cannot exceed 999,999,999.99"),
  deposit_date: z
    .string()
    .min(1, "Deposit date is required")
    .refine((val) => !isNaN(Date.parse(val)), "Invalid date")
    .refine(
      (val) => new Date(val) <= new Date(),
      "Deposit date cannot be in the future"
    ),
  note: z.string().optional(),
  source_account_id: z.string().optional(),
  deposit_currency: z.string().optional(),
});

export type DepositFormValues = z.infer<typeof depositFormSchema>;
